// extracted by mini-css-extract-plugin
module.exports = {"dueDateItem":"paymentusagedetail_dueDateItem__3qeW9","btnCol":"paymentusagedetail_btnCol__1cjv9"};